import { makeStyles } from '@material-ui/core/styles';

export type SummaryMinimalClasses = 'vehicleTitlePriceLabel' | 'modelTitlePriceLabel';

const summaryMinimalStyles = makeStyles(
  () => ({
    vehicleTitlePriceLabel: {},
    modelTitlePriceLabel: {},
  }),
  { name: 'Customise_SummaryMinimal' },
);

export default summaryMinimalStyles;
